module.exports = __webpack_public_path__ + "img/76.0a3d4af6.jpg";